export default class ValidacionCertificacionTss {
    constructor(
        public aplicaTramite?: boolean,
        public estado?: string,
        public mensaje?: string,
        public numeroCertificacion?: string,
        public fecha?: string
    ) {}
}